import { BemBlock } from '../BemBlock';

BemBlock.each('reuploadField', (block) => {
	const input = block.getBemElement<HTMLInputElement>('file');
	const clear = block.getBemElement<HTMLInputElement>('clear');
	const thumbnail = block.getBemElement<HTMLImageElement>('thumbnail');
	const resetButton = block.getBemElement<HTMLButtonElement>('reset');

	if (!input || !thumbnail || !resetButton) {
		console.error('Missing required elements', block.element);
		return;
	}

	const originalSrc = thumbnail.element.dataset.src ?? null;
	const required = input.element.required;
	if (required && originalSrc) {
		input.element.required = false;
		input.element.classList.remove('required');
		input.element.ariaRequired = null;
		if (input.element.form) {
			$(input.element.form).trigger('revalidate');
		}
	}

	const setSelectedFile = (file: File) => {
		if (clear) {
			clear.element.checked = false;
		}
		thumbnail.element.src = URL.createObjectURL(file);
		if (thumbnail.element.complete) {
			block.addModifier('hasValue');
			block.addModifier('hasChanged');
		} else {
			block.addModifier('loading');
		}
	};

	const handleThumbnailLoad = () => {
		block.removeModifier('loading');
		block.addModifier('hasValue');
		block.toggleModifier(
			'hasChanged',
			thumbnail.element.attributes.getNamedItem('src')?.value !==
				originalSrc
		);
	};

	const clearSelectedFile = () => {
		block.removeModifier('hasValue');
		block.removeModifier('loading');
		if (clear) {
			clear.element.checked = true;
		}
		thumbnail.element.src = '';
		input.element.value = '';
		block.toggleModifier('hasChanged', !!originalSrc);
	};

	const reset = () => {
		block.removeModifier('hasChanged');
		if (originalSrc) {
			block.addModifier('hasValue');
			if (clear) {
				clear.element.checked = false;
			}
			thumbnail.element.src = originalSrc;
		} else {
			block.removeModifier('hasValue');
			thumbnail.element.src = '';
		}
		input.element.value = '';
	};

	input.element.addEventListener('input', () => {
		const file = input.element.files?.item(0);
		if (file) {
			setSelectedFile(file);
		} else {
			clearSelectedFile();
		}
	});

	clear?.element.addEventListener('input', () => {
		clearSelectedFile();
	});

	thumbnail.element.addEventListener('load', () => {
		handleThumbnailLoad();
	});

	resetButton.element.addEventListener('click', () => {
		reset();
	});
});
